var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    "+_vm._s(_vm.$acl.not.check('isAdmin'))+"\n    "),(_vm.$acl.not.check('isAdmin'))?_c('button',[_vm._v("\n    Set admin permisson\n    ")]):_c('button',[_vm._v("\n    Set public permission\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }